import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { Person } from "@common/ADAPT.Common.Model/person/person";
import { AdaptClientConfiguration } from "@common/configuration/adapt-client-configuration";
import { Autobind } from "@common/lib/autobind.decorator/autobind.decorator";
import { ThemeService } from "@common/shell/theme.service";
import { UserService } from "@common/user/user.service";
import { ConfigureFeatureBase } from "@org-common/lib/configuration/base-components/configure-feature-base";
import { IConfigItem } from "@org-common/lib/configuration/configuration.interfaces";
import { ConfigurationService } from "@org-common/lib/configuration/configuration.service";

@Component({
    selector: "adapt-configure-personal-theme",
    templateUrl: "./configure-personal-theme.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class ConfigurePersonalThemeComponent extends ConfigureFeatureBase {
    @Input() public configItem?: IConfigItem;

    public person?: Person;
    public readonly projectLabel = AdaptClientConfiguration.AdaptProjectLabel;

    public options = [
        { name: "Default", value: 0 },
        { name: "Green", value: 1 },
        { name: "Burgundy", value: 2 },
    ];

    public constructor(
        configurationService: ConfigurationService,
        private userService: UserService,
        private themeService: ThemeService,
    ) {
        super(configurationService);
    }

    @Autobind
    public async initialiseData() {
        this.person = await this.userService.getCurrentPerson();
    }

    public updateTheme(themeId: number) {
        this.themeService.setTheme(themeId);
    }
}
